import { render } from "./headers.vue?vue&type=template&id=6622bbe8&scoped=true"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"

import "./headers.vue?vue&type=style&index=0&id=6622bbe8&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6622bbe8"]])

export default __exports__